import { useToast } from 'vue-toastification'

export class HttpClientClass {
  baseURL = ''

  constructor(baseURL: string) {
    this.baseURL = baseURL
  }

  async request(
    method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE',
    url: string,
    { data = null, manageLoading = false, isFormData = false } = {}
  ) {
    const headers = new Headers()

    if (!isFormData) {
      headers.append('Content-Type', 'application/json')
    }

    const headersObject = Object.fromEntries(headers.entries())

    const options: Record<string, any> = {
      method,
      headers: headersObject,
      credentials: 'include',
    }

    if (data) {
      options.body = isFormData ? data : JSON.stringify(data)
    }

    try {
      const response = await fetch(`${this.baseURL}${url}`, options)

      // No content
      if (response.status === 204) {
        return {
          ok: response.ok,
          status: response.status,
        }
      }

      const responseData = await response.json()

      if (!response.ok) {
        await this.handleGlobalErrors(response, responseData)
      }

      return {
        ok: response.ok,
        status: response.status,
        data: responseData,
      }
    } catch (error: any) {
      // console.error(error)
      error.value = error?.message || 'An error occurred'
      useToast().error(error.value)
    }
  }

  async handleGlobalErrors(response: Response, responseData: any) {
    if (response.status === 401) {
      if (import.meta.client) {
        // Session na API vypršela – zahodit i lokálního uživatele, jinak by
        // nás guard z přihlašovací obrazovky poslal zpátky dovnitř
        localStorage.removeItem('user')
        sessionStorage.clear()

        const current = window.location.pathname + window.location.search
        const redirect =
          current && current !== '/'
            ? `?redirect=${encodeURIComponent(current)}`
            : ''
        window.location.href = `/${redirect}`
      }
      return
    }
    // console.error(responseData.message)
    useToast().error(responseData.message)
  }

  get(url: string, options: Record<string, any> = {}) {
    return this.request('GET', url, options)
  }

  post(url: string, data: any, options: Record<string, any> = {}) {
    return this.request('POST', url, { ...options, data })
  }

  patch(url: string, data: any, options: Record<string, any> = {}) {
    return this.request('PATCH', url, { ...options, data })
  }

  put(url: string, data: any, options: Record<string, any> = {}) {
    return this.request('PUT', url, { ...options, data })
  }

  delete(url: string, options: Record<string, any> = {}) {
    return this.request('DELETE', url, options)
  }
}

const HttpClient = new Proxy({} as any, {
  get(_, method: 'get' | 'post' | 'put' | 'patch' | 'delete') {
    return (...args: any[]) => {
      const client = useNuxtApp().$http as HttpClientClass
      return (client[method] as any)(...args)
    }
  },
})

export default HttpClient
